import React, { useEffect, useState } from "react";
import api, { FOUNDATION } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Layout";
import { MagazineCard } from "@/components/MagazineCard";

export default function Magazine() {
  const [issues, setIssues] = useState([]);
  const [year, setYear] = useState("सभी");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/magazines").then((res) => setIssues(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const years = ["सभी", ...Array.from(new Set(issues.map((i) => i.year).filter(Boolean))).sort((a, b) => b.localeCompare(a))];
  const filtered = year === "सभी" ? issues : issues.filter((i) => i.year === year);

  return (
    <div>
      <PageHeader testId="magazine-header" title="टूरिस्ट संदेश मासिक" subtitle={`वर्ष ${FOUNDATION.magazineYear} से निरंतर प्रकाशित मासिक पत्रिका का संग्रह`} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        {years.length > 1 && (
          <div className="flex gap-2 flex-wrap mb-8" data-testid="magazine-year-filter">
            {years.map((y) => (
              <button key={y} onClick={() => setYear(y)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  year === y ? "bg-amber-500 text-white" : "bg-white border border-amber-200 text-[#0a2540] hover:bg-amber-50"
                }`}>{y === "सभी" ? "सभी वर्ष" : y}</button>
            ))}
          </div>
        )}

        {loading ? (
          <div className="text-center py-20 text-slate-400">लोड हो रहा है...</div>
        ) : filtered.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
            {filtered.map((m) => <MagazineCard key={m.id} issue={m} />)}
          </div>
        ) : (
          <EmptyState icon="newspaper" message={issues.length ? "इस वर्ष का कोई अंक नहीं मिला।" : "अभी तक कोई अंक नहीं जोड़ा गया है।"} />
        )}
      </section>
    </div>
  );
}
